import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { GuestFolioService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { GuestFolio } from '../../models'

const log = new Logger('GuestFolioDetailResolver')
@Injectable({ providedIn: 'root' })
export class GuestFolioDetailResolver
  implements Resolve<Observable<GuestFolio>> {
  constructor(
    private guestFolioService: GuestFolioService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['pid']
    
    return this.guestFolioService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/guestfolio']))
    )
  }
}
